import HomeIcon from '@material-ui/icons/Home';
import React from 'react';
import StyledBreadcrumb, { StyledBreadcrumbProps } from '../StyledBreadcrumb';

export type StyledBreadcrumbHomeProps = Omit<StyledBreadcrumbProps, 'to'>;

const StyledBreadcrumbHome = React.forwardRef<HTMLAnchorElement, StyledBreadcrumbHomeProps>((props, ref) => (
  <StyledBreadcrumb {...props} ref={ref} to='/' icon={<HomeIcon fontSize='small' />} />
));

StyledBreadcrumbHome.displayName = 'StyledBreadcrumbHome';

export default StyledBreadcrumbHome;
